export const SET_ADMIN_STAKEHOLDERS_REQUEST = 'SET_ADMIN_STAKEHOLDERS_REQUEST';
export const SET_ADMIN_STAKEHOLDERS_SUCCESS = 'SET_ADMIN_STAKEHOLDERS_SUCCESS';
export const SET_ADMIN_STAKEHOLDERS_FAILED = 'SET_ADMIN_STAKEHOLDERS_FAILED';
export const SET_ADMIN_STAKEHOLDERS_LIST_SUCCESS = 'SET_ADMIN_STAKEHOLDERS_LIST_SUCCESS';
export const SET_ADMIN_STAKEHOLDERS_SCENARIO_SUCCESS = 'SET_ADMIN_STAKEHOLDERS_SCENARIO_SUCCESS';
export const CLEAN_ADMIN_STAKEHOLDERS = 'CLEAN_ADMIN_STAKEHOLDERS';
